import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { User, UserFormValues, UserPasswordFormValues } from "../models/user";
import { store } from "./store";
import { history } from "../..";

export default class UserStore{

    user: User | null = null;
    loading: boolean = false;
    verifySuccess: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    get isLoggedIn() {
        return !!this.user;
    }

    login = async(creds: UserFormValues) => {
        try{
            const user = await agent.Account.login(creds);
            store.commonStore.setToken(user.token);
            runInAction(() => {
                this.user = user;
            });
            history.push('/org');
            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }

    logout = () => {
        store.commonStore.setToken(null);
        window.localStorage.removeItem('jwt');
        this.user = null;
        history.push('/');
    }

    verifyEmail = async (email: string, code: string) => {
        this.setLoading(true);
        try {
            const result = await agent.Account.confirmEmail({ email, code });
            runInAction(() => {
                this.setVerifySuccess(result.success);
                this.setLoading(false);
            })
        } catch (error) {
            console.log(error);
            this.setLoading(false);
        }
        return false;
    }

    getUser = async () => {
        try {
            const user = await agent.Account.current();
            runInAction(() => this.user = user);
        } catch (error) {
            console.log(error);
        }
    }

    register = async (creds: UserFormValues) => {
        try{
            const user = await agent.Account.register(creds);
            store.commonStore.setToken(user.token);
            runInAction(() => this.user = user);
            history.push('/org');
            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }

    updatePassword = async (creds: UserPasswordFormValues) => {
        try{
            const user = await agent.Account.updatePassword(creds);
            store.commonStore.setToken(user.token);
            runInAction(() => this.user = user);
            history.push('/org');
            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    setVerifySuccess = (verified: boolean) => {
        this.verifySuccess = verified;
    }

    setDisplayName = (name: string) => {
        if(this.user) this.user.displayName = name;
    }
}